module.exports = __webpack_public_path__ + "static/media/sars.8c9ff455.png";